
import React from 'react'
import "./style.css"
import logo from 'images/logo.png'
export default function Home() {
    return (
        <div className='rootHome'>
            <div className='homeContent'>
                <div className='homeContentCenter'>
                    <img className='logoHome' src={logo} alt="Logo" />
                </div >
                <p>A App Nelore é um aplicativo móvel para auxiliar no gerenciamento de animais nascidos no seu rebanho. A ferramenta permite lançar as informações de maneira simples e rápida através de colaboradores a campo.</p>
                <p>As fazendas que aderirem a essa ferramenta, terão maior agilidade no controle de nascimentos, permitindo a emissão de um relatório diário.</p>
                <p>A tecnologia facilita a rotina dos colaboradores e facilita a comunicação do campo ao escritório. Permitindo que várias pessoas da fazenda possam acompanhar em tempo real os lançamentos dos dados.</p>
            </div>
        </div>
    )
}
